export const moreLessText = () => {
	// console.log('moreLessText init');
	const els = document.querySelectorAll('.contents');

	els.forEach((el) => {
		const mark = el.querySelector('.mark');
		const toggle = el.querySelector('.more-toggle');

		// Create a new span to wrap the text following the markSpan
		const hiddenText = document.createElement('span');
		hiddenText.classList.add('hidden-text');
		hiddenText.style.display = 'none'; // Initially hide the text

		// Move all nodes after mark into the hiddenText
		while (mark.nextSibling) {
			hiddenText.appendChild(mark.nextSibling);
		}

		// Insert hiddenText after mark
		mark.parentNode.insertBefore(hiddenText, mark.nextSibling);

		// On button click, toggle content
		toggle.addEventListener('click', () => {
			// console.log('moreLessText clicked');
			// Toggle the .expanded class on the .contents div
			el.classList.toggle('expanded');

			const isExpanded = el.classList.contains('expanded');

			// Toggle the visibility of the hidden text & update aria attributes
			hiddenText.style.display = isExpanded ? '' : 'none';

			// Update the button text based on data attributes
			toggle.textContent = isExpanded ? toggle.getAttribute('data-less-label') : toggle.getAttribute('data-more-label');

			toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
		});
	});
};
